import React from 'react';
import { FallbackProps } from 'react-error-boundary';

import { ErrorPageMessage } from './ErrorPageMessage';

export const ErrorPageFallback = ({ error }: FallbackProps) => (
  <ErrorPageMessage errorCode="Error" message={error.message} />
);
